import { ReactNode } from 'react';
import { useDisabledSectionStyle } from './useDisabledSectionStyle';

export const DisabledSection = ({ children, disabled }: { children: ReactNode; disabled?: boolean }) => {
    const { classes, cx } = useDisabledSectionStyle();
    return <div className={cx(disabled ? classes.disabledSection : classes.activeSection)}>{children}</div>;
};
